import RouterSection from '@/components/layout/RouterSection'

export default {
  path: '/payment',
  name: 'payment-index',
  component: RouterSection,
  redirect: '/paymnet/list',
  children: [
    {
      path: 'list',
      name: 'payment-list-index',
      component: () => import('@/views/payment/Payment.vue'),
      props : true
    },
    {
      path: 'list/:payment_history_seq',
      name: 'payment-history-index',
      component: () => import('@/views/payment/Payment.vue'),
      props : true
    }
  ]
}
